import { RemoteGetAllSsoProviders } from 'data/usecases/sso-providers';
import { makeApiUrlSsoProviders } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllSsoProviders = (): RemoteGetAllSsoProviders => {
  return new RemoteGetAllSsoProviders(
    makeApiUrlSsoProviders(),
    makeAxiosHttpClient(),
  );
};
